import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import { BRAND } from './api.routes'
import { BrandsResponse, BrandsState, GetBrandsPayload } from '../models'

import ActionTypes from '../constants'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllBrandsThunk = createAsyncThunk(
  ActionTypes.GET_ALL_BRANDS,
  async (payload: GetBrandsPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'GET',
        endpoint: BRAND.BRANDS_ALL,
        queries: jsonToQueryString({ ...payload, limit: 9999 }),
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: BrandsResponse = await restApiService.getAuthData(
        auth.token || '',
      )

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

const getAllBrandsExtraReducer = (
  builder: ActionReducerMapBuilder<BrandsState>,
) => {
  builder.addCase(getAllBrandsThunk.pending, (state) => {
    state.isLoading = true
  })
  builder.addCase(getAllBrandsThunk.fulfilled, (state, { payload }) => {
    state.isLoading = false
    state.brands = payload.docs
  })
}

export default getAllBrandsExtraReducer
